import { render } from "./ProjectStageCard.vue?vue&type=template&id=76654a12&scoped=true&ts=true"
import script from "./ProjectStageCard.vue?vue&type=script&lang=ts"
export * from "./ProjectStageCard.vue?vue&type=script&lang=ts"

import "./ProjectStageCard.vue?vue&type=style&index=0&id=76654a12&scoped=true&lang=scss"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76654a12"]])

export default __exports__